import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { statusColours } from '../../constants/ColourConstants';

import { Card, CardHeader, CardText } from 'material-ui/Card';
import { Link } from 'react-router';

import ModuleIcon from 'material-ui/svg-icons/social/school';

import ModuleActions from '../../actions/ModuleActionCreator';
import ModuleStore from '../../stores/ModuleStore';

class EventModuleSegment extends Component {
    constructor() {
        super(...arguments);
        this.state = { moduleId: null, moduleName: null };
    }

    componentWillMount() {
        this.onModuleChange();
    }

    componentDidMount() {
        this.onModuleChange = this.onModuleChange.bind(this);
        this.moduleListener = ModuleStore.addListener(this.onModuleChange);
        ModuleActions.getByEvent(this.props.eventId);
    }

    componentWillUnmount() {
        this.moduleListener.remove();
    }

    render() {
        if (!this.state.moduleId) { return null; } //guard

        return (
            <Card className="cent-card">
                <CardHeader title="Module" avatar={<ModuleIcon color={statusColours.default}/>}/>
                <CardText>
                    <Link to={`/dashboard/module/${this.state.moduleId}?eventId=${this.props.eventId}`}>
                        {this.state.moduleName}
                    </Link>
                </CardText>
            </Card>
        );
    }

    onModuleChange() {
        const module = ModuleStore.getByEvent(this.props.eventId);
        if (!!module) {
            this.setState({ moduleId: module.id, moduleName: module.name });
        }
    }
}

EventModuleSegment.proptypes = { eventId: PropTypes.number.isRequired };

export default EventModuleSegment;
